import type { FaireProductEntity } from "../../entity_types/product";

export const p_tp8vrwqcu2: FaireProductEntity = {
  token: "p_tp8vrwqcu2",
  type: "product",
  name: "Psalm of Praise Teethers",
  brandToken: "b_j4dyen6dfe",
  brandName: "Remnant House Home Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/3a694449e8af4c59c03e790f38b156bab03dbf84ca7ec5d9ff65703054e323ab.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a297b650483ba100e50244481e913ea462294e5e397f6fb29ed83655ef8f86b.png",
    "https://cdn.faire.com/fastly/93229736198c6efc467dbb6eff57ee5ff3e6b9682e1d038c29ab3b6ae3b2b792.jpeg",
  ],
  priceDollars: 6,
  description:
    'These neutral color teethers with a powerful declaration over your precious babe will be their absolute favorite. Its bubble wheel design is perfect for their little fingers to grasp and soothing for their gums in those teething months. The Psalm of Praise Teethers come in 4 neutral colors for any modern style preference. All four colors have the verse, \n"Out of the mouth of babes, You have perfected praise." -Psalm 8:3\n\nCrafted from 100% food-grade silicone, our teethers are BPA-free, phthalate-free, and non-toxic, lovingly made to meet the highest safety standards—including CPSIA, FDA, LFGB, ASTM F963, and EN 71—so you can trust they’re pure, gentle, and perfectly safe for your little one’s mouth.',
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:15.115Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
